import React, { useEffect, useRef, useState } from "react";
import { useDebounce } from "use-debounce";

import { useDispatch, useSelector } from "react-redux";
import { Table, Pagination, Radio, Checkbox, AutoComplete, Spin } from "antd";
import { useConfirmModal } from "components/Modal/ConfirmModal";

import { Button, Icon } from "antd";
import capitalize from "capitalize";

import "./HistoryVisitors.less";

// == import i18n
import { useTranslation } from "react-i18next";

// == import component
import { Input, Empty, message } from "antd";
import { listVisitorsHistory, releaseKeyCards } from "services/features/VisitsSlice";
import moment from "moment";
import { SearchOutlined } from "@ant-design/icons";

const { Search } = Input;

const HistoryVisitors = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const searchRef = useRef();

  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText] = useDebounce(searchText, 500);
  const [visitors, setVisitors] = useState([]);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const [searching, setSearching] = useState(false);

  const [askUserConfirm, ConfirmModal] = useConfirmModal();
  const [options, setOptions] = useState([]);

  const load = async () => {
    if (!debouncedSearchText) {
      setVisitors([]);
      setSelectedVisitor();
      setOptions([]);
      return;
    }
    setSearching(true);
    const vis = await dispatch(listVisitorsHistory(debouncedSearchText));
    setVisitors(vis);
    setOptions(
      vis.map(v => ({
        value:
          capitalize.words(v.firstname || "") +
          " " +
          (v.lastname || "").toUpperCase() +
          ` (${v.company || v.email})`,
        key: v.id,
      })),
    );
    setSearching(false);
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    load();
  }, [debouncedSearchText]);

  const handleSelect = async (value, record) => {
    const aVisitor = visitors.find(v => v.id === record.key);
    aVisitor.history = (aVisitor.history || [])
      .filter(v => !!v.event)
      .map(v => ({
        ...v,
        data: {
          ...v.data,
          visitDate: moment(v.data.visitDate).format("DD/MM/YYYY HH:mm"),
        },
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
    setSelectedVisitor(aVisitor);
  };

  const columns = [
    {
      title: t("VisitorHistoryDate"),
      dataIndex: "date",
      className: "historyVisitor__table__header",
      width: "20%",
      render: (text, record) => <span>{moment(record.date).format("DD/MM/YYYY HH:mm")}</span>,
    },
    {
      title: t("VisitorHistoryEvent"),
      dataIndex: "type",
      className: "historyVisitor__table__header",
      render: (text, record) => {
        return (
          <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {t(`VisitorHistoryEvent_${record.event}`, record.data)}
          </div>
        );
      },
    },
  ];

  return (
    <div className="historyVisitor" style={{ height: window.innerHeight }}>
      {ConfirmModal}
      <p
        className="historyVisitor_instructions"
        style={{ marginTop: "100px", marginBottom: "35px" }}
      >
        {t("VisitorHistoryInstruction")}
      </p>
      <AutoComplete
        ref={searchRef}
        style={{ zIndex: 9, width: "700px", fontSize: "23px" }}
        options={options}
        onSearch={e => {
          setSearchText(e);
        }}
        onSelect={handleSelect}
        loading={searching}
        size="large"
      >
        <Input
          style={{ fontSize: "23px" }}
          suffix={searching ? <Spin size="small" /> : <SearchOutlined />}
          placeholder={t("VisitorName")}
        />
      </AutoComplete>
      {selectedVisitor ? (
        (selectedVisitor.history || []).length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<span>{t("VisitorNoHistory")}</span>}
          />
        ) : (
          <Table
            dataSource={selectedVisitor.history}
            columns={columns}
            rowKey="id"
            pagination={false}
            style={{ width: "1400px", marginTop: "50px", marginBottom: "50px" }}
            scroll={{ y: 300 }}
          />
        )
      ) : null}
    </div>
  );
};

export default HistoryVisitors;
